export const WALLET_TRANSACTION_FILTER = {
  ALL: 'all',
  DEBIT: 'debit',
  CREDIT: 'credit',
} as const

export type WalletTransactionFilter = typeof WALLET_TRANSACTION_FILTER[keyof typeof WALLET_TRANSACTION_FILTER]

export type WalletTransactionDirection = 'debit' | 'credit'

export interface WalletSummary {
  balance: number
  currency: 'LAK'
  currencySymbol: string
  currencyAbbr: string | null
  softLimit: number
  hardLimit: number
  updatedAt: string
  isBankDetailsEnable: boolean
  accountNumber: string | null
  accountHolderName: string | null
}

export interface WalletActionState {
  payableAmount: number
  withdrawableAmount: number
  canPay: boolean
  canWithdraw: boolean
  status: 'payable' | 'withdrawable' | 'settled'
}

export interface WalletTransaction {
  id: string
  bookingId: string | null
  title: string
  amount: number
  direction: WalletTransactionDirection
  createdAt: string
}

export interface WalletBankTransferRequest {
  direction: 'pay_due_to_loca' | 'payout_to_driver'
  amount: string | number
  latitude?: string
  longitude?: string
  idempotency_key: string
}

export interface WalletBankTransferResult {
  idempotencyKey: string
  xref: string | null
  duplicate: boolean
  direction: 'pay_due_to_loca' | 'payout_to_driver' | string | null
  provider: string | null
  amount: number
  currency: string
  bankStatus: string | null
  walletStatus: string | null
  overallStatus: string | null
  bankRefNo: string | null
  requestedAt: string | null
  message: string | null
}
